<template>
  <v-app>
    <v-main>
      <Header/>
      <v-container class="d-flex pa-0" fluid>
        <router-view />
      </v-container>
    </v-main>
    <Footer/>
  </v-app>
</template>
<script>
import { mapActions } from 'vuex'
import Header from '@/components/layouts/default/Header'
import Footer from '@/components/layouts/default/Footer'
export default {
  name: 'LayoutDefault',
  components: {
    Header,
    Footer
  },
  methods: {
    ...mapActions('auth', ['checkToken'])
  },
  mounted () {
    this.checkToken()
  }
}
</script>
<style lang="scss" scoped>
#app{
  background-image: url('~@/assets/images/background.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
</style>
